// extracted by mini-css-extract-plugin
module.exports = {"card":"TimestampCard_card__YMLK8","text":"TimestampCard_text__vd8Vt","textColor":"TimestampCard_textColor__zQsVi"};